import web3 from './web3';
import walletAbi from "../Abi/externalWalletAbi.json";
import {getContractAddress} from "../utils/contractHelpers";
export default new web3.eth.Contract(walletAbi, getContractAddress("wallet"));
